export const VoyageTableHeaders = {
  VESSEL: {label: 'Vessel.Labels.Vessel', description: 'VesselList.Labels.VesselDesc'},
  NAME: {label: 'MovementActionList.Labels.VoyageId', description: 'MovementActionList.Labels.VoyageIdDesc'},
  ARRIVAL_DETAILS: {label: 'VoyageBrowser.Labels.ArrivalDetails', description: 'VoyageBrowser.Labels.ArrivalDetailsDesc'},
  DEPARTURE_DETAILS: {label: 'VoyageBrowser.Labels.DepartureDetails', description: 'VoyageBrowser.Labels.DepartureDetailsDesc'},
  STATUS: {label: 'VoyageBrowser.Labels.Status', description: 'VoyageBrowser.Labels.StatusDesc'}
}